export default "__VITE_ASSET__be744200__"